import type { FC } from "react";

type IconModule = {
  [key: string]: FC<any> | undefined;
  default?: FC<any>;
};

type IconEntry = {
  component: FC<any>;
  path: string;
};

export const Icons: Record<string, IconEntry> = {};

let req: any = null;

try {
  // Try to get require.context - will fail in test environment
  req = require.context("./", true, /\.(tsx|jsx)$/);
} catch (error) {
  // In test environment, require.context doesn't exist
  console.log("require.context not available - likely in test environment");
}

if (req) {
  req.keys().forEach((key: string) => {
    const mod: IconModule = req(key) as IconModule;

    const fileName = key
      .split("/")
      .pop()
      ?.replace(/\.(tsx|jsx)$/, "");
    const fullPath = key.replace(/^\.\//, "").replace(/\.(tsx|jsx)$/, "");

    if (!fileName) return;

    // Add default export if present
    if (mod.default && typeof mod.default === "function") {
      Icons[fileName] = {
        component: mod.default,
        path: fullPath,
      };
    }

    // Add all named exports too
    Object.entries(mod).forEach(([exportName, component]) => {
      if (typeof component === "function") {
        Icons[exportName] = {
          component,
          path: fullPath,
        };
      }
    });
  });
}

type SvgEntry = {
  src: string;
  path: string;
};

export const SvgIcons: Record<string, SvgEntry> = {};

let svgReq: any = null;

try {
  // Try to get require.context for SVG files
  svgReq = require.context("../../static/images", true, /\.svg$/);
} catch (error) {
  // In test environment, require.context doesn't exist
  console.log("SVG require.context not available - likely in test environment");
}

if (svgReq) {
  svgReq.keys().forEach((key: string) => {
    const fileName = key
      .split("/")
      .pop()
      ?.replace(/\.svg$/, "");
    const publicPath = svgReq(key) as string; // This becomes a URL due to Webpack loader
    const fullPath = `static/images/${key.replace(/^\.\//, "")}`;

    if (!fileName) return;

    SvgIcons[fileName] = {
      src: publicPath,
      path: fullPath,
    };
  });
}
